import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const GameBannersRoutes: Routes = [
  {
    path: "game-banners",
    loadComponent: () =>
      import("./game-banners/game-banners.component").then(
        (m) => m.GameBannersComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./game-banners-list/game-banners-list.component").then(
            (m) => m.GameBannersListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./game-banners-form/game-banners-form.component").then(
            (m) => m.GameBannersFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./game-banners-form/game-banners-form.component").then(
            (m) => m.GameBannersFormComponent,
          ),
      },
    ],
  },
];
